import { render, staticRenderFns } from "./irregular.vue?vue&type=template&id=1734f7c0&scoped=true"
import script from "./irregular.vue?vue&type=script&lang=js"
export * from "./irregular.vue?vue&type=script&lang=js"
import style0 from "./irregular.vue?vue&type=style&index=0&id=1734f7c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1734f7c0",
  null
  
)

export default component.exports